import { ui } from '@beelday/common'
import styled from '@emotion/styled'
import { ScriptNavigation, useAutoStartScript } from 'features/script'
import { FC } from 'react'
import { use100vh } from 'react-div-100vh'
import { RoomContainer } from 'room/common/presentation/room-container'
import RoomHeader from 'room/common/presentation/room-header'
import { MiscPanel } from 'room/misc'
import { ConfiguredPresentButton } from 'presenter-mode/configured-present-button'
import { ConfiguredPresenterPanel } from 'presenter-mode/configured-presenter-panel'
import TrainerMenuInPerson from 'room/training-room/trainer-menu-in-person'
import { InPersonStage } from './in-person-stage'

/**
 * The stage and, while presenting, the presenter panel beside it. The stage
 * keeps its place in the tree either way, so starting or ending a
 * presentation never remounts what is on it (a playing film keeps playing).
 */
const Body = styled.div`
	display: flex;
	flex: 1;
	min-height: 0;
	width: 100%;
`

/**
 * The trainer's room on a laptop wired to a projector.
 *
 * Deliberately the ordinary live-session room: `RoomHeader` stays in flow with
 * the organisation branding, the exit control and `ScriptNavigation` exactly
 * where the trainer already expects them, and `MiscPanel` stays the same
 * overlay drawer. Present in the header opens presenter mode
 * (`presenter-mode/`): the stage goes full screen on the projector and this
 * window becomes its console, with the presenter panel beside the stage.
 *
 * The stage is bigger for two reasons and no others: there is no video to
 * place beside it, and the menu no longer reserves height.
 */
export const RoomTrainerInPerson: FC = () => {
	const containerHeight = use100vh()
	// The agenda starts as the trainer walks in; the Start script bar in the
	// header stays as the way in when that does not happen.
	useAutoStartScript()

	return (
		<RoomContainer
			style={{
				height: `${containerHeight}px`,
			}}
		>
			<RoomHeader actions={<ConfiguredPresentButton />}>
				<ScriptNavigation />
			</RoomHeader>
			<Body>
				<InPersonStage menu={<TrainerMenuInPerson />} />
				<ConfiguredPresenterPanel />
			</Body>

			<MiscPanel />
			<ui.BeeldayLogoAbsoluteBottom />
		</RoomContainer>
	)
}
